import { useEffect, useState } from 'react'
import { Calendar, ArrowRight, CheckCircle } from 'lucide-react'

export default function PostPayment() {
  const [countdown, setCountdown] = useState(5)

  useEffect(() => {
    // Clear pending user data
    localStorage.removeItem('ith_pending_user_id')
    localStorage.removeItem('ith_pending_email')

    // Countdown then redirect to Calendly
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          window.location.href = 'https://calendly.com/realestateos/inside-this-home-onboarding'
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  const goToCalendly = () => {
    window.location.href = 'https://calendly.com/realestateos/inside-this-home-onboarding'
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full p-8 bg-white rounded-lg shadow text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <CheckCircle className="text-green-600" size={32} />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Payment Successful!
        </h1>
        <p className="text-gray-600 mb-6">
          Your InsideThisHome account is ready. 
          Book your onboarding call to get started.
        </p>

        <button
          onClick={goToCalendly}
          className="w-full flex items-center justify-center gap-2 py-3 px-4 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors mb-4"
        >
          <Calendar size={20} />
          Book Onboarding Call
          <ArrowRight size={18} />
        </button>

        <p className="text-sm text-gray-500">
          Redirecting to Calendly in {countdown} seconds...
        </p>
      </div>
    </div>
  )
}